import React from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import { useLoaderData } from "react-router";

import { sanitize } from "dompurify";

import { store } from "../..";
import "../../assets/css/majorybl/pages/tryouts.scss";
import {
    globalActions,
    selectSetting,
} from "../../features/global/globalSlice";
import { useAppSelector } from "../../hooks/reduxHooks";
import { getLooking } from "../../lib/api";
import { IAPIResponse, ILookingForPlayers } from "../../types/api";

export const loader = async () => {
    const settings = store.getState().global.settings;
    const settingsPromise = settings.length
        ? Promise.resolve()
        : store.dispatch(globalActions.getSettings());

    await Promise.resolve(settingsPromise);

    return {
        looking: await getLooking(),
    };
};

const LookingForPlayers = (): React.JSX.Element => {
    const {
        looking: { looking: lookingList },
    } = useLoaderData() as {
        looking: IAPIResponse & { looking: ILookingForPlayers[] };
    };

    const lfpText = useAppSelector(state =>
        selectSetting(state, "majorybl_lfp_page_content"),
    );

    return (
        <div data-testid="lookingForPlayersContent">
            <Container className="py-5 lookingForPlayers">
                <Row>
                    <Col>
                        <h2>Teams Looking for Players</h2>
                        <div
                            className="no-bottom-pad"
                            dangerouslySetInnerHTML={{
                                __html: sanitize(lfpText?.setting),
                            }}
                        />

                        {lookingList.length !== 0 ? (
                            <Table
                                striped
                                bordered
                                responsive="lg"
                                className="lookingForPlayers"
                            >
                                <thead>
                                    <tr>
                                        <th>Age</th>
                                        <th>Team/Organization</th>
                                        <th>Positions</th>
                                        <th>Description</th>
                                        <th>Contact Info</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {lookingList
                                        .sort((a, b) => {
                                            const aAge = a.age
                                                ? parseInt(a.age[0])
                                                : 0;
                                            const bAge = b.age
                                                ? parseInt(b.age[0])
                                                : 0;
                                            const ageCheck = aAge - bAge;

                                            return ageCheck !== 0
                                                ? ageCheck
                                                : a.team.localeCompare(b.team);
                                        })
                                        .map(t => (
                                            <tr key={t.id}>
                                                <td>{t.age?.join(", ")}</td>
                                                <td>{t.team}</td>
                                                <td>
                                                    {t.position?.join(", ")}
                                                </td>
                                                <td width={"40%"}>
                                                    {t.description || "-"}
                                                </td>
                                                <td>
                                                    <b>{t.contactName}</b>
                                                    <br />
                                                    <a
                                                        href={`mailto: ${t.contactEmail}`}
                                                    >
                                                        {t.contactEmail}
                                                    </a>
                                                    <br />
                                                    {t.contactNumber}
                                                    <br />
                                                    {t.contactSite && (
                                                        <a
                                                            href={
                                                                /http/.test(
                                                                    t.contactSite,
                                                                )
                                                                    ? t.contactSite
                                                                    : `http://${t.contactSite}`
                                                            }
                                                        >
                                                            visit website
                                                        </a>
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                                </tbody>
                            </Table>
                        ) : (
                            <h5>No teams currently looking for players</h5>
                        )}
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default LookingForPlayers;
